import { Directive } from '@angular/core';
import { FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appDownpaymentValidation]'
})
export class DownpaymentValidationDirective {

  constructor() { }

}
export function downpaymentMaxValidator(form: FormGroup, maxValue): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      // console.log('', control);
      // console.log('', form);
      var downpaymentAmount = form.controls['downPaymentAmount'].value;
      if (downpaymentAmount.length > 0) {
        downpaymentAmount = downpaymentAmount.replace(/,/g, '');
        downpaymentAmount = Number(downpaymentAmount);
      }
      if (downpaymentAmount) {
        if (downpaymentAmount > maxValue) {
          return { 'downpaymentMaxValidation': { value: downpaymentAmount } };
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}

export function downpaymentMinValidator(form: FormGroup, minValue): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control && control.value && form) {
      // console.log('', control);
      // console.log('', form);
      var downpaymentAmount = form.controls['downPaymentAmount'].value;
      if (downpaymentAmount.length > 0) {
        downpaymentAmount = downpaymentAmount.replace(/,/g, '');
        downpaymentAmount = Number(downpaymentAmount);
      }
      if (downpaymentAmount) {
        if (downpaymentAmount < minValue) {
          return { 'downpaymentMinValidation': { value: downpaymentAmount } };
        } else {
          return null;
        }
      } else {
        return null;
      }
    } else {
      return null;
    }
  };
}

